<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulas',
                  params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="primary" class="mb-5 d-flex" outlined>
          <v-card-text>
            <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
            <template v-if="!gestaoDeAula.is_polivalencia">
              <h4>Disciplina: {{ gestaoDeAula.disciplina?.descricao }}</h4>
            </template>
            <template v-else>
              <h4>Disciplinas:</h4>
              <div class="container">
                <div class="row">
                  <div v-for="(item, index) in gestaoDeAula.disciplinas" :key="index">
                    <v-chip class="ml-2" x-small>{{ item.descricao }} </v-chip>
                  </div>
                </div>
              </div>
            </template>
            <h4>
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[Carregando...]" }}
            </h4>
            <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAula.turma.turno.descricao : "[NÃO INFORMADO]"
              }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <ValidationObserver v-if="etapas" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col cols="12" md="8" v-if="etapas?.length">
            <ValidationProvider name="Etapa" rules="required" v-slot="{ errors }">
              <div class="d-flex align-center">
                <div class="flex-grow-1">
                  <e-label
                    >Etapas
                    <v-chip
                      small
                      v-if="etapaSelecionada?.periodo_extensao"
                      class="text-none"
                      :color="getChipColor(etapaSelecionada?.periodo_extensao)"
                    >
                      Estendido até: {{ dateFormatConvert(etapaSelecionada?.periodo_extensao) }}
                    </v-chip>
                    <v-chip
                      small
                      class="text-none"
                      style="color: #fff"
                      color="green darken-3"
                      v-if="
                        etapaSelecionada &&
                        pedidoAprovado &&
                        etapaSelecionada?.periodo_extensao === null
                      "
                      >Solicitação de Lançamento de Aulas Aprovada -
                      <strong v-if="pedidoAprovado.data_expiracao">
                        Válido até {{ validarData(pedidoAprovado.data_expiracao) }}</strong
                      >
                      <strong v-else>Prazo Indefinido</strong>
                    </v-chip>
                    <v-chip
                      small
                      class="text-none"
                      style="color: #fff"
                      color="red darken-3"
                      v-if="!pedidoAprovado && !etapaPendente && pedidoRecusado"
                      >Seu último pedido de lançamento de aula nessa etapa foi recusado!
                    </v-chip>
                    <v-chip
                      small
                      class="text-none"
                      style="color: #fff"
                      color="red darken-3"
                      v-if="pedidoExpirado === true && !pedidoAprovado"
                      >Seu último pedido para lançamento de aula já expirou
                    </v-chip>
                  </e-label>
                  <e-autocomplete
                    v-if="editing"
                    :items="etapas"
                    :return-object="false"
                    :error-messages="errors"
                    :item-text="
                      (item) =>
                        `${item.descricao} - Início: ${dateFormatConvert(
                          item.periodo_inicial
                        )} Fim: ${dateFormatConvert(item.periodo_final)}`
                    "
                    :item-value="(item) => item.id"
                    v-model="etapaSelecionada"
                    @change="() => verificarEtapaSelecionada()"
                    label="Selecione uma Etapa"
                    dense
                    solo
                  />

                  <e-autocomplete
                    v-else
                    :items="etapas"
                    :return-object="false"
                    :error-messages="errors"
                    :item-text="
                      (item) =>
                        `${item.descricao} - Início: ${dateFormatConvert(
                          item.periodo_inicial
                        )} Fim: ${dateFormatConvert(item.periodo_final)} ${
                          item.periodo_extensao
                            ? ' - Estendido até: ' + dateFormatConvert(item.periodo_extensao)
                            : ''
                        }`
                    "
                    :item-value="(item) => item.id"
                    v-model="etapaSelecionada"
                    @change="() => verificarEtapaSelecionada()"
                    label="Selecione uma Etapa"
                    dense
                    solo
                  />
                </div>

                <v-tooltip v-if="!editing" bottom max-width="400">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="primary" class="ml-2" v-bind="attrs" v-on="on" small>
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <div class="tooltip-content">
                    <div class="font-weight-bold mb-2">Para que serve a etapa?</div>
                    <div class="mb-2">Você seleciona a etapa para:</div>
                    <ul class="tooltip-list mb-2">
                      <li>• Dizer em qual período a aula entra (ex.: MARÇO, ABRIL)</li>
                      <li>• Liberar o cadastro (só pode lançar aulas dentro das datas da etapa)</li>
                      <li>• Organizar faltas (As faltas pertencem a uma etapa)</li>
                    </ul>
                    <div class="font-weight-bold">Exemplo:</div>
                    <div>
                      Aula dada em 10/06 → Seleciona "JUNHO". Se escolher outra etapa, o sistema
                      bloqueia.
                    </div>
                  </div>
                </v-tooltip>
              </div>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" md="4" class="d-flex align-center">
            <v-btn
              v-if="etapaBloqueada == true && etapaPendente == false"
              style="box-shadow: none"
              color="success"
              class="text-none"
              @click="() => criarPedido(etapaSelecionada?.id)"
              >Solicitar Autorização</v-btn
            >
          </v-col>
        </v-row>

        <div v-if="etapaSelecionada && etapaBloqueada == false">
          <v-row>
            <v-col cols="12" md="12">
              <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
                <e-label>Tipo de Aula</e-label>
                <e-autocomplete
                  :items="$constants.tiposDeAulas"
                  :return-object="false"
                  :error-messages="errors"
                  v-model="aulaSelecionada.tipo_de_aula"
                  @change="() => verificaTipoDaAula()"
                  label="Selecione um tipo de aula"
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row v-if="aulaSelecionada.tipo_de_aula !== 'Reposição'">
            <v-col cols="12" md="6">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="data"
                persistent
                width="450px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <e-label>Selecione uma data</e-label>
                  <v-text-field
                    v-model="aulaSelecionada.data"
                    persistent-hint
                    :disabled="aulaSelecionada.tipo_de_aula ? false : true"
                    label="Escolha uma data"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    solo
                  ></v-text-field>
                </template>

                <v-card>
                  <v-container class="calendar-container">
                    <v-row>
                      <v-col cols="12" md="12" class="d-flex justify-center">
                        <v-card class="calendar-card pa-3" elevation="2" outlined>
                          <v-date-picker
                            v-model="data"
                            full-width
                            scrollable
                            :min="inicioPeriodoEtapa"
                            :max="fimPeriodoEtapa"
                            :allowed-dates="allowedDates"
                            :events="[
                              ...feriados.map((f) => f.data),
                              ...eventosLetivosDia.map((e) => e.data),
                              ...eventosQueBloqueiamAulas.map((e) => e.data),
                            ]"
                            :event-color="getEventColor"
                            @update:picker-date="atualizarMesVisivel"
                            color="primary"
                            header-color="primary"
                          >
                            <template v-slot:day="{ date, day }">
                              <v-badge
                                :color="getBadgeColor(date)"
                                :content="getBadgeContent(date)"
                                overlap
                                dot
                              >
                                <span :class="{ 'font-weight-bold': isToday(date) }">{{
                                  day
                                }}</span>
                              </v-badge>
                            </template>
                          </v-date-picker>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="12">
                        <v-card class="events-card" elevation="2" outlined>
                          <v-card-title class="primary white--text pa-4">
                            <v-icon left color="white">mdi-calendar-month</v-icon>
                            Eventos do Mês
                          </v-card-title>

                          <v-divider></v-divider>

                          <v-list dense class="py-0">
                            <div v-for="(evento, index) in eventosFiltradosPorMes" :key="index">
                              <v-divider v-if="index > 0"></v-divider>
                              <v-list-item class="px-4">
                                <v-list-item-icon class="mr-3">
                                  <v-icon :color="evento.cor">mdi-circle-small</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title class="d-flex align-center">
                                    <span class="date-label mr-2">{{
                                      formatarDia(evento.data)
                                    }}</span>
                                    <span>
                                      {{ evento.descricao }}
                                      <v-chip
                                        v-if="
                                          evento.tipo === 'bloqueio' &&
                                          (evento.legenda
                                            ?.toLowerCase()
                                            .includes('lançamento bloqueado') ||
                                            evento.legenda
                                              ?.toLowerCase()
                                              .includes('lancamento bloqueado') ||
                                            evento.descricao
                                              ?.toLowerCase()
                                              .includes('lançamento bloqueado') ||
                                            evento.descricao
                                              ?.toLowerCase()
                                              .includes('lancamento bloqueado'))
                                        "
                                        x-small
                                        color="red darken-2"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Lançamento Bloqueado
                                      </v-chip>
                                      <v-chip
                                        v-else-if="evento.tipo === 'bloqueio'"
                                        x-small
                                        color="red darken-2"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Dia não letivo
                                      </v-chip>
                                      <v-chip
                                        v-else-if="
                                          evento.tipo === 'letivo' &&
                                          (evento.legenda
                                            ?.toLowerCase()
                                            .includes('lançamento aberto') ||
                                            evento.legenda
                                              ?.toLowerCase()
                                              .includes('lancamento aberto') ||
                                            evento.descricao
                                              ?.toLowerCase()
                                              .includes('lançamento aberto') ||
                                            evento.descricao
                                              ?.toLowerCase()
                                              .includes('lancamento aberto'))
                                        "
                                        x-small
                                        color="green darken-1"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Lançamento Aberto
                                      </v-chip>
                                      <v-chip
                                        v-else-if="evento.tipo === 'letivo'"
                                        x-small
                                        color="green"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Dia Letivo
                                      </v-chip>
                                      <v-chip
                                        v-else-if="evento.tipo === 'feriado'"
                                        x-small
                                        color="red lighten-1"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Feriado
                                      </v-chip>
                                    </span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </div>

                            <v-list-item v-if="eventosFiltradosPorMes.length === 0">
                              <v-list-item-content>
                                <v-list-item-title class="text-caption grey--text">
                                  Nenhum evento neste mês
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(data)">OK</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos && aulaSelecionada.tipo_de_aula === 'Reposição'">
            <v-col cols="12" md="6">
              <v-dialog
                ref="dialog_reposicao"
                v-model="modal_reposicao"
                :return-value.sync="data_reposicao"
                persistent
                width="450px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <e-label>Selecione uma data</e-label>
                  <v-text-field
                    v-model="aulaSelecionada.data_reposicao"
                    persistent-hint
                    :disabled="aulaSelecionada.tipo_de_aula ? false : true"
                    label="Escolha uma data"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    solo
                  ></v-text-field>
                </template>

                <v-card>
                  <v-container class="calendar-container">
                    <v-row>
                      <v-col cols="12" md="12" class="d-flex justify-center">
                        <v-card class="calendar-card pa-3" elevation="2" outlined>
                          <v-date-picker
                            v-model="data_reposicao"
                            full-width
                            scrollable
                            :min="inicioPeriodoEtapa"
                            :max="fimPeriodoEtapa"
                            :allowed-dates="allowedDatesReposicao"
                            color="primary"
                            header-color="primary"
                          >
                          </v-date-picker>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-btn text color="primary" @click="modal_reposicao = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog_reposicao.save(data_reposicao)"
                      >OK</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col cols="12" md="6" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
              <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                <e-label>Selecione um horário</e-label>
                <e-autocomplete
                  :disabled="
                    aulaSelecionada.tipo_de_aula === 'Reposição'
                      ? !aulaSelecionada.data_reposicao
                      : !aulaSelecionada.data
                  "
                  :items="horarios"
                  label="Selecione um horário"
                  :item-text="(item) => item.descricao"
                  v-model="horarioSelecionado"
                  @change="() => handleHorarioChange()"
                  return-object
                  :error-messages="errors"
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col cols="12">
              <ValidationProvider name="Conteúdo" rules="required" v-slot="{ errors }">
                <e-label>Conteúdo</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.conteudo"
                  :error-messages="errors"
                  placeholder="Descreva o conteúdo da aula..."
                  rows="3"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col cols="12" md="6">
              <ValidationProvider name="Habilidades" rules="required" v-slot="{ errors }">
                <e-label>Habilidades</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.objetivos_ou_habilidades"
                  :error-messages="errors"
                  placeholder="Descreva as habilidades trabalhadas..."
                  rows="4"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" md="6">
              <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
                <e-label>Metodologia</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.metodologia"
                  :error-messages="errors"
                  placeholder="Descreva a metodologia utilizada..."
                  rows="4"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col cols="12" class="d-flex flex-wrap gap-3">
              <v-btn
                color="primary"
                :disabled="submittingForm || !todosOsCamposObrigatoriosPreenchidos"
                :loading="submittingForm"
                type="submit"
                class="mr-3"
                >Enviar Dados</v-btn
              >
              <v-btn
                v-if="editing"
                color="success"
                outlined
                @click="dialog.duplicar = true"
                class="mr-3"
                >Duplicar Aula</v-btn
              >
              <v-btn v-if="editing" color="info" outlined @click="dialog.exportar = true"
                >Exportar Aula</v-btn
              >
            </v-col>
          </v-row>
        </div>

        <v-row v-if="etapas?.length === 0">
          <v-col cols="12">
            <v-alert type="warning" border="left" class="mb-4">
              <v-icon left>mdi-alert-circle</v-icon>
              Não existem etapas disponíveis para a data atual
            </v-alert>
          </v-col>
        </v-row>

        <v-row v-if="pedidoExpirado && !pedidoAprovado">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left" class="mb-4">
              <v-icon left>mdi-lock</v-icon>
              <strong>Atenção! </strong> Seu último pedido expirou. Para solicitar um novo pedido,
              clique no botão "Solicitar Autorização" acima.
            </v-alert>
          </v-col>
        </v-row>
        <v-row
          v-else-if="
            etapaBloqueada == true && etapaPendente == false && !pedidoRecusado && !pedidoAprovado
          "
        >
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left" class="mb-4">
              <v-icon left>mdi-lock</v-icon>
              <strong>Atenção!</strong> Esta etapa está bloqueada. Para lançar aulas você deve
              solicitar uma autorização clicando no botão "Solicitar Autorização" acima.
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-else-if="!pedidoAprovado && !etapaPendente && pedidoRecusado">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left" class="mb-4">
              <v-icon left>mdi-lock</v-icon>
              <strong>Atenção!</strong> Seu pedido foi recusado. Para solicitar um novo pedido,
              clique no botão "Solicitar Autorização" acima.
            </v-alert>
          </v-col>
        </v-row>

        <v-row v-if="etapaPendente == true && etapaSelecionada?.periodo_extensao === null">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="info" border="left" class="mb-4">
              <v-icon left>mdi-clock-outline</v-icon>
              <strong>Aguarde!</strong> Já existe um pedido de autorização para essa etapa e estamos
              analisando.
            </v-alert>
            <v-btn color="primary" outlined small @click="verPedidos">
              <v-icon left small>mdi-eye</v-icon>
              Acompanhe seus pedidos
            </v-btn>
          </v-col>
        </v-row>

        <v-row v-if="etapas?.length > 0 && etapaBloqueada == false && etapaSelecionada">
          <v-col
            cols="12"
            v-if="
              !aulaSelecionada.tipo_de_aula ||
              (aulaSelecionada.tipo_de_aula === 'Reposição'
                ? !aulaSelecionada.data_reposicao
                : !aulaSelecionada.data) ||
              (!horarioSelecionado && aulaSelecionada.tipo_de_aula !== 'Aula Remota')
            "
          >
            <v-alert type="warning" border="left" class="mb-4">
              <v-icon left>mdi-information</v-icon>
              Por favor, preencha todos os campos obrigatórios!
            </v-alert>
          </v-col>
        </v-row>
      </form>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
            Fechar
          </v-btn>

          <h2 class="mt-4">Aulas conflitadas</h2>

          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horario</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Disciplina</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="item in aulasConflitadas" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>
                    {{ item.professor.nome }}
                    <br />
                    <v-chip color="grey" dark x-small>
                      {{ item.turma.franquia.descricao }}
                    </v-chip>
                  </td>
                  <td>{{ item.situacao ? item.situacao : "Aguardando" }}</td>
                  <td>
                    <span>
                      {{ item.data.split("-").reverse().join("/") }}
                    </span>
                    - {{ item.horario.descricao }}
                  </td>
                  <td>{{ item.turma.descricao }}</td>
                  <td>{{ item.disciplina.descricao }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>
    <v-alert text border="left" color="orange" icon="warning" class="text-caption" v-else
      >Atenção, essa turma ainda não foi vinculada a um circuito, para fazer isso você tem que ir em
      Turmas->Editar e Selecione o Circuito desejado, caso seja um professor aguarde o responsável
      realizar esse procedimento.</v-alert
    >
    <e-modal-duplicar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :horarios="horarios"
      :form="{ ...aulaSelecionada }"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula>
    <e-modal-exportar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      @dialogChange="dialog.exportar = $event"
    >
    </e-modal-exportar-aula>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";
import { dateFormatParam } from "../../plugins/filters";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    aula_id: {
      type: Number,
      require: true,
    },
  },
  computed: {
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
    eventosFiltradosPorMes() {
      if (!this.mesVisivel) return [];
      const todosEventos = [
        ...this.feriados.map((f) => ({ ...f, tipo: "feriado" })),
        ...this.eventosLetivosDia.map((e) => ({ ...e, tipo: "letivo" })),
        ...this.eventosQueBloqueiamAulas.map((e) => ({ ...e, tipo: "bloqueio" })),
      ];
      return todosEventos
        .filter((evento) => evento.data.startsWith(this.mesVisivel))
        .sort((a, b) => {
          return parseInt(a.data.split("-")[2], 10) - parseInt(b.data.split("-")[2], 10);
        });
    },
    todosOsCamposObrigatoriosPreenchidos() {
      if (!this.etapaSelecionada) return false;
      if (!this.aulaSelecionada.tipo_de_aula) return false;
      if (this.aulaSelecionada.tipo_de_aula === "Reposição") {
        if (!this.aulaSelecionada.data_reposicao) return false;
      } else if (!this.aulaSelecionada.data) return false;
      if (this.aulaSelecionada.tipo_de_aula !== "Aula Remota" && !this.horarioSelecionado) {
        return false;
      }
      if (!this.aulaSelecionada.conteudo || this.aulaSelecionada.conteudo.trim() === "") {
        return false;
      }
      if (
        !this.aulaSelecionada.objetivos_ou_habilidades ||
        this.aulaSelecionada.objetivos_ou_habilidades.trim() === ""
      ) {
        return false;
      }
      if (!this.aulaSelecionada.metodologia || this.aulaSelecionada.metodologia.trim() === "") {
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.loadData();
    if (this.editing) {
      this.mostrarCampos = true;
    }
    this.carregarFeriados();
  },
  data() {
    return {
      pedidoExpirado: false,
      diasPermitidosParaCriarAula: [0, 1, 2, 3, 4, 5, 6],
      avisoAnime: "",
      etapaPendente: false,
      etapaBloqueada: false,
      idsEtapasDisponivels: [],
      idsEtapasPendentes: [],
      fimPeriodoEtapa: null,
      inicioPeriodoEtapa: null,
      etapaSelecionada: null,
      etapas: null,
      data: null,
      data_reposicao: null,
      modal: false,
      modal_reposicao: false,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      mostrarCampos: false,
      submittingForm: false,
      form: {},
      aulaSelecionada: {
        data: null,
        data_reposicao: null,
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      horarios: [],
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      aulaDuplicada: {},
      gestaoDeAulas: null,
      dialog: {
        duplicar: false,
        exportar: false,
      },
      feriados: [],
      eventosLetivosDia: [],
      eventosQueBloqueiamAulas: [],
      mesVisivel: null,
      eventos: [],
      pedidoAprovado: null,
      pedidoRecusado: null,
    };
  },
  watch: {
    tipo_de_aula(newValue, oldValue) {
      this.aulasEmConflitos = false;
      this.aulasConflitadas = [];
      this.mostrarCampos = true;

      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota") {
        this.aulaSelecionada.horario_inicial = null;
        this.aulaSelecionada.horario_final = null;
        this.horarioSelecionado = null;
      }

      if (oldValue === "Reposição" && newValue !== "Reposição") {
        if (this.aulaSelecionada.data_reposicao && !this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data_reposicao;
          const partesData = this.aulaSelecionada.data_reposicao.split("/");
          if (partesData.length === 3) {
            this.data = `${partesData[2]}-${partesData[1]}-${partesData[0]}`;
          }
        }
        this.aulaSelecionada.data_reposicao = null;
        this.data_reposicao = null;
        const horarioAtual = this.horarioSelecionado;
        if (this.data) {
          const dataSelecionada = new Date(this.data);
          const diaDaSemana = dataSelecionada.getDay();
          this.filtrarHorariosPorDiaDaSemana(diaDaSemana);

          this.$nextTick(() => {
            if (horarioAtual && this.horarios.find((h) => h.id === horarioAtual.id)) {
              this.horarioSelecionado = this.horarios.find((h) => h.id === horarioAtual.id);
            } else {
              this.horarioSelecionado = null;
            }
          });
        }
      } else if (oldValue !== "Reposição" && newValue === "Reposição") {
        if (this.aulaSelecionada.data && !this.aulaSelecionada.data_reposicao) {
          this.aulaSelecionada.data_reposicao = this.aulaSelecionada.data;
          const partesData = this.aulaSelecionada.data.split("/");
          if (partesData.length === 3) {
            this.data_reposicao = `${partesData[2]}-${partesData[1]}-${partesData[0]}`;
          }
        }
        this.aulaSelecionada.data = null;
        this.data = null;
        const horarioAtual = this.horarioSelecionado;
        this.carregarTodosHorariosdoTurno();
        this.$nextTick(() => {
          if (horarioAtual && this.horarios.find((h) => h.id === horarioAtual.id)) {
            this.horarioSelecionado = this.horarios.find((h) => h.id === horarioAtual.id);
          } else {
            this.horarioSelecionado = null;
          }
        });
      }
    },
    data_reposicao(value) {
      if (!value) return;

      const dataFormatada = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(new Date(value));

      this.aulaSelecionada.data_reposicao = dataFormatada;
      this.horarioSelecionado = null;
      this.carregarTodosHorariosdoTurno();
    },
    data(value) {
      if (!value) return;

      const data_old = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(new Date(value));
      this.aulaSelecionada.data = data_old.replaceAll("/", "/");

      const eventoBloqueador = this.verificarEventoBloqueiaAula(this.aulaSelecionada.data);
      if (eventoBloqueador) {
        const legenda = eventoBloqueador.legenda?.toLowerCase() || "";
        const descricao = eventoBloqueador.descricao?.toLowerCase() || "";

        let tipoEvento = "bloqueia";
        if (
          legenda.includes("lançamento bloqueado") ||
          legenda.includes("lancamento bloqueado") ||
          descricao.includes("lançamento bloqueado") ||
          descricao.includes("lancamento bloqueado")
        ) {
          tipoEvento = "tem lançamento bloqueado e";
        }

        this.$toast.warning(
          `Não é possível criar aulas nesta data. Evento: "${eventoBloqueador.descricao}" ${tipoEvento} bloqueia o lançamento de aulas.`
        );
        return;
      }

      const dataSelecionada = new Date(value);
      const diaDaSemana = dataSelecionada.getDay();
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana);
      this.horarioSelecionado = null;
      if (this.aulaSelecionada.tipo_de_aula !== "Reposição") {
        this.pesquisaAulas();
      }
    },
  },
  methods: {
    validarData(data) {
      return dateFormatParam(data, "d/m/y");
    },
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      if (!this.gestaoDeAula.relacoesDiasHorarios) return;

      const horariosDoDia = this.gestaoDeAula.relacoesDiasHorarios
        .filter((relacao) => relacao.dia.id === diaDaSemana)
        .map((relacao) => relacao.horario);

      this.horarios = horariosDoDia;

      if (diaDaSemana === 5) {
        this.horariosSabado = this.horarios.map((h) => ({
          id: h.id,
          turno_id: h.turno_id,
          descricao: h.descricao.split(" - ")[0],
          final: h.final,
          inicio: h.inicio,
        }));
        this.horariosDoComponente = this.horariosSabado;
      } else {
        this.horariosDoComponente = this.horarios;
      }
    },
    carregarTodosHorariosdoTurno() {
      if (!this.gestaoDeAula.turma?.turno?.id) return;
      const turnoId = this.gestaoDeAula.turma.turno.id;
      if (!this.gestaoDeAula.relacoesDiasHorarios) return;
      const todosHorarios = this.gestaoDeAula.relacoesDiasHorarios
        .map((relacao) => relacao.horario)
        .filter((horario) => horario.turno_id === turnoId)
        .filter((horario, index, self) => index === self.findIndex((h) => h.id === horario.id));

      this.horarios = todosHorarios;
    },
    handleHorarioChange() {
      if (this.aulaSelecionada.tipo_de_aula === "Reposição") {
        this.pesquisaAulasReposicao();
      } else {
        this.pesquisaAulas();
      }
    },
    dateFormatConvert(data, format = null) {
      return dateFormatParam(data, format);
    },
    animarAviso() {
      this.avisoAnime = "animate__animated animate__headShake";
      setTimeout(() => (this.avisoAnime = ""), 500);
    },
    verificarEtapaSelecionada() {
      this.animarAviso();
      this.inicioPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada)
        .shift().periodo_inicial;
      this.inicioPeriodoEtapa = this.dateFormatConvert(this.inicioPeriodoEtapa, "y-m-d");
      this.fimPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada)
        .shift().periodo_final;
      this.fimPeriodoEtapa = this.dateFormatConvert(this.fimPeriodoEtapa, "y-m-d");

      const etapaVerificar = this.etapas.filter((d) => d.id === this.etapaSelecionada).shift();

      this.verificarSeEtapaEstaDisp(etapaVerificar);
    },
    verificarSeEtapaEstaDisp(etapa) {
      if (this.idsEtapasDisponivels.includes(etapa.id)) {
        // se etapa.periodo_final for menor que a data atual tem que bloquear
        if (new Date(etapa.periodo_final) < new Date()) {
          this.etapaBloqueada = true;
          this.pedidoExpirado = true;
        } else {
          this.etapaBloqueada = false;
          this.pedidoExpirado = false;
        }
      } else {
        this.etapaBloqueada = true;
      }
      this.verificarSeTemPedido(etapa.id);
    },
    async verificarSeTemPedido(etapaId) {
      const response = await this.$services.autorizacoesService.verificarPedidosDeferidos(
        etapaId,
        1
      );

      if (response.data.recusados) {
        // pegar o ultimo pedido recusado
        this.pedidoRecusado = response.data.recusados[response.data.recusados.length - 1];
      }

      this.pedidoAprovado = null;
      if (response.data.aprovados?.length) {
        const [pedidoAprovado] = response.data.aprovados;
        this.pedidoAprovado = pedidoAprovado;
        this.etapaBloqueada = false;
      }

      if (response.data.aprovados?.length) {
        this.idsEtapasDisponivels.push(etapaId);
      }

      if (response.data.pendentes?.length) {
        this.idsEtapasPendentes.push(etapaId);
      }

      if (this.idsEtapasPendentes.includes(etapaId)) {
        this.etapaPendente = true;
      }
    },
    criarPedido(etapaId) {
      this.$router.push({ name: "autorizacoes.create", params: { etapa: etapaId, tipo: "aula" } });
    },
    verPedidos() {
      this.$router.push({ name: "autorizacoes" });
    },
    allowedDates(val) {
      const dataFormatada = new Date(val).toISOString().split("T")[0];

      const partes = val.split("-");
      const ano = parseInt(partes[0], 10);
      const mes = parseInt(partes[1], 10) - 1;
      const dia = parseInt(partes[2], 10);
      const diaDaSemana = new Date(ano, mes, dia).getDay();

      // Verificar se algum evento bloqueia esta data
      const eventoBloqueia = this.eventosQueBloqueiamAulas.some(
        (evento) => new Date(evento.data).toISOString().split("T")[0] === dataFormatada
      );

      if (eventoBloqueia) {
        return false;
      }

      // Verificar se algum evento permite aulas nesta data
      const eventoPermiteAula = this.eventosLetivosDia.some(
        (evento) => new Date(evento.data).toISOString().split("T")[0] === dataFormatada
      );

      if (eventoPermiteAula) {
        return true;
      }

      // Verificar se é feriado
      const ehFeriado = this.feriados.some(
        (feriado) => new Date(feriado.data).toISOString().split("T")[0] === dataFormatada
      );

      if (ehFeriado) {
        return false;
      }

      if (this.gestaoDeAula?.turma?.dias_da_semana?.length > 0) {
        const diasSemanaMap = {
          0: "Domingo",
          1: "Segunda",
          2: "Terça",
          3: "Quarta",
          4: "Quinta",
          5: "Sexta",
          6: "Sábado",
        };

        const nomeDiaDaSemana = diasSemanaMap[diaDaSemana];
        return this.gestaoDeAula.turma.dias_da_semana.includes(nomeDiaDaSemana);
      }

      // Permitir apenas dias úteis (segunda a sexta) por padrão
      return diaDaSemana >= 1 && diaDaSemana <= 5;
    },
    allowedDatesReposicao(val) {
      // Para reposição, permitir apenas sábados
      const partes = val.split("-");
      const ano = parseInt(partes[0], 10);
      const mes = parseInt(partes[1], 10) - 1;
      const dia = parseInt(partes[2], 10);
      const diaDaSemana = new Date(ano, mes, dia).getDay();
      return diaDaSemana === 6;
    },
    async pesquisaAulas() {
      if (this.aulaSelecionada.tipo_de_aula === "Reposição") {
        return;
      }
      if (!this.aulaSelecionada.data) return;

      const data_aula = this.aulaSelecionada.data.split("/").reverse().join("-");
      const horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
      const turma_id = this.gestaoDeAula.turma.id;
      const { aula_id } = this.$route.params;

      if (!data_aula || !this.aulaSelecionada) return;

      const response = await this.$services.aulasService.pesquisarAulasEmConflitos(
        data_aula,
        horario_id,
        turma_id,
        aula_id
      );

      if (response.data.length <= 0) {
        this.mostrarCampos = true;
        this.aulasEmConflitos = false;
        this.aulasConflitadas = [];
      }

      if (response.data.length > 0) {
        this.aulasEmConflitos = true;
        this.aulasConflitadas = response.data;
        this.mostrarCampos = false;
        this.horarioSelecionado = null;
      }
    },
    async pesquisaAulasReposicao() {
      const data_aula = this.aulaSelecionada.data_reposicao.split("/").reverse().join("-");
      const horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
      const turma_id = this.gestaoDeAula.turma.id;
      const { aula_id } = this.$route.params;

      if (!data_aula || !this.aulaSelecionada) return;

      const response = await this.$services.aulasService.pesquisarAulasEmConflitos(
        data_aula,
        horario_id,
        turma_id,
        aula_id
      );

      if (response.data.length <= 0) {
        this.mostrarCampos = true;
        this.aulasEmConflitos = false;
        this.aulasConflitadas = [];
      }

      if (response.data.length > 0) {
        this.aulasEmConflitos = true;
        this.aulasConflitadas = response.data;
        this.mostrarCampos = false;
        this.horarioSelecionado = null;
      }
    },
    async verificaTipoDaAula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota" || this.editing) {
        this.getAula();
        this.mostrarCampos = true;
        return;
      }
      this.mostrarCampos = true;
    },
    async submitForm() {
      this.aulaSelecionada.horario_inicial = this.horarioSelecionado
        ? this.horarioSelecionado.inicio
        : null;
      this.aulaSelecionada.horario_final = this.horarioSelecionado
        ? this.horarioSelecionado.final
        : null;
      this.aulaSelecionada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
      this.aulaSelecionada.etapa_id = this.etapaSelecionada;

      this.submittingForm = true;
      try {
        if (this.editing) {
          this.aulaSelecionada.gestao_de_aula = parseInt(this.$route.params.gestaoDeAulaId, 10);
          if (
            this.aulaSelecionada.tipo_de_aula === "Reposição" &&
            this.aulaSelecionada.data_reposicao
          ) {
            this.aulaSelecionada.data_reposicao = this.aulaSelecionada.data_reposicao
              .split("/")
              .reverse()
              .join("-");
            this.aulaSelecionada.data = this.aulaSelecionada.data_reposicao;
          } else if (this.aulaSelecionada.data) {
            this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          }

          await this.$services.aulasService.atualizar(this.aulaSelecionada);
          this.$toast.success("Aula editada com sucesso!");
        } else {
          this.aulaSelecionada.gestao_de_aula = parseInt(this.$route.params.gestaoDeAulaId, 10);
          this.aulaSelecionada.disciplina_id = this.gestaoDeAula.disciplina_id;
          this.aulaSelecionada.turma_id = this.gestaoDeAula.turma_id;
          this.aulaSelecionada.instrutor_id = this.gestaoDeAula.instrutor_id;
          if (
            this.aulaSelecionada.tipo_de_aula === "Reposição" &&
            this.aulaSelecionada.data_reposicao
          ) {
            this.aulaSelecionada.data_reposicao = this.aulaSelecionada.data_reposicao
              .split("/")
              .reverse()
              .join("-");
            this.aulaSelecionada.data = this.aulaSelecionada.data_reposicao;
          } else if (this.aulaSelecionada.data) {
            this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
          }

          await this.$services.aulasService.criar(this.aulaSelecionada);
          this.$toast.success("Aula cadastrada com sucesso!");
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
      this.$router.push({
        name: "aulas",
      });
    },

    async getAula() {
      const { aula_id } = this.$route.params;
      const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.$route.params.gestaoDeAulaId
      );
      this.gestaoDeAula = response.gestaoDeAula;
      this.horarios = response.horarios;

      const aulaSelecionada = await this.$services.aulasService.getAula(parseInt(aula_id, 10));

      if (this.editing && aulaSelecionada.horario_id) {
        this.horarioSelecionado =
          this.horarios.find((h) => h.id === aulaSelecionada.horario_id) || null;
      }

      return aulaSelecionada;
    },
    async loadData() {
      // this.getGestaoDeAula();
      try {
        this.$loaderService.open("Carregando dados...");
        this.aulaSelecionada = await this.getAula();

        // Carregar etapas se a turma tiver circuito
        if (this.gestaoDeAula.turma.circuito_nota_id) {
          const response = await this.$services.etapasService.syncAllEtapasDisponiveis(
            this.gestaoDeAula.turma.circuito_nota_id,
            this.$route.params.gestaoDeAulaId,
            "aula"
          );
          this.etapas = response.etapas;
          this.idsEtapasDisponivels = response.disponiveis;

          this.$loaderService.open("Carregando dados...");
          for (const [index, id] of this.etapas.entries()) {
            await new Promise((r) => setTimeout(r, 200 * index)); // espera 200ms por id
            await this.verificarSeTemPedido(id);
          }
          this.$loaderService.close();

          if (this.editing) {
            this.getEtapa();
          }
        }

        if (this.aulaSelecionada.data) {
          const dataOriginal = this.aulaSelecionada.data;
          this.data = dataOriginal;
          this.aulaSelecionada.data = dataOriginal.split("-").reverse().join("/");
        }

        if (this.aulaSelecionada.data_reposicao) {
          const dataReposicaoOriginal = this.aulaSelecionada.data_reposicao;
          this.data_reposicao = dataReposicaoOriginal;
          this.aulaSelecionada.data_reposicao = dataReposicaoOriginal
            .split("-")
            .reverse()
            .join("/");
        }
        if (this.aulaSelecionada.tipo_de_aula === "Reposição") {
          this.carregarTodosHorariosdoTurno();
          await this.$nextTick();
        }

        if (this.editing && this.aulaSelecionada.horario_id && this.horarios.length > 0) {
          this.horarioSelecionado =
            this.horarios.find((h) => h.id === this.aulaSelecionada.horario_id) || null;
        }

        this.$forceUpdate();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    getEtapa() {
      if (this.aulaSelecionada.etapa_id && this.etapas) {
        let etapa = this.etapas.filter((d) => d.id === this.aulaSelecionada.etapa_id);
        if (etapa.length > 0) {
          etapa = etapa.shift();
          this.fimPeriodoEtapa = this.dateFormatConvert(etapa.periodo_final, "y-m-d");
          this.inicioPeriodoEtapa = this.dateFormatConvert(etapa.periodo_inicial, "y-m-d");
          this.etapaSelecionada = etapa.id;
        }
      }
    },

    async carregarFeriados() {
      try {
        const response = await this.$services.calendarioLetivoService.syncAll();

        this.feriados = response
          .filter((evento) => evento.evento.is_feriado === true)
          .map((evento) => ({
            data: evento.start,
            descricao: evento.descricao,
            cor: evento.color,
          }));

        this.eventosLetivosDia = response
          .filter((evento) => {
            const legenda = evento.evento.legenda?.toLowerCase() || "";
            const descricao = evento.descricao?.toLowerCase() || "";
            return (
              evento.evento.is_sabado_letivo === true ||
              evento.evento.permite_aulas === true ||
              legenda.includes("lançamento aberto") ||
              legenda.includes("lancamento aberto") ||
              descricao.includes("lançamento aberto") ||
              descricao.includes("lancamento aberto")
            );
          })
          .map((evento) => ({
            data: evento.start,
            descricao: evento.descricao,
            cor: evento.color,
            permite_aulas: true,
            legenda: evento.evento.legenda,
          }));

        this.eventosQueBloqueiamAulas = response
          .filter((evento) => {
            const legenda = evento.evento.legenda?.toLowerCase() || "";
            const descricao = evento.descricao?.toLowerCase() || "";

            if (evento.evento.is_feriado === true) return false;

            const jaEhLetivo =
              evento.evento.is_sabado_letivo === true ||
              evento.evento.permite_aulas === true ||
              legenda.includes("lançamento aberto") ||
              legenda.includes("lancamento aberto") ||
              descricao.includes("lançamento aberto") ||
              descricao.includes("lancamento aberto");

            if (jaEhLetivo) return false;

            return true;
          })
          .map((evento) => ({
            data: evento.start,
            descricao: evento.descricao,
            cor: evento.color,
            legenda: evento.evento.legenda,
          }));
      } catch (error) {
        this.$handleError(error);
      }
    },

    verificarEventoBloqueiaAula(data) {
      const dataFormatada = data.split("/").reverse().join("-");
      return this.eventosQueBloqueiamAulas.find((evento) => evento.data === dataFormatada);
    },

    atualizarMesVisivel(pickerDate) {
      const [ano, mes] = pickerDate.split("-");
      this.mesVisivel = `${ano}-${mes}`;
    },

    formatarDia(data) {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}`;
    },

    isFeriado(date) {
      return this.feriados.some((f) => f.data === date);
    },

    isEventoLetivo(date) {
      return this.eventosLetivosDia.some((e) => e.data === date);
    },

    isEventoBloqueador(date) {
      return this.eventosQueBloqueiamAulas.some((e) => e.data === date);
    },

    getBadgeColor(date) {
      if (this.isFeriado(date)) return "red";
      if (this.isEventoBloqueador(date)) {
        const evento = this.eventosQueBloqueiamAulas.find((e) => e.data === date);
        const legenda = evento?.legenda?.toLowerCase() || "";
        const descricao = evento?.descricao?.toLowerCase() || "";

        if (
          legenda.includes("lançamento bloqueado") ||
          legenda.includes("lancamento bloqueado") ||
          descricao.includes("lançamento bloqueado") ||
          descricao.includes("lancamento bloqueado")
        ) {
          return "red darken-2";
        }
        return "red darken-1";
      }
      if (this.isEventoLetivo(date)) {
        const evento = this.eventosLetivosDia.find((e) => e.data === date);
        const legenda = evento?.legenda?.toLowerCase() || "";
        const descricao = evento?.descricao?.toLowerCase() || "";

        if (
          legenda.includes("lançamento aberto") ||
          legenda.includes("lancamento aberto") ||
          descricao.includes("lançamento aberto") ||
          descricao.includes("lancamento aberto")
        ) {
          return "green darken-1";
        }
        return "green";
      }
      return "";
    },

    getBadgeContent(date) {
      if (this.isFeriado(date)) return "F";
      if (this.isEventoBloqueador(date)) {
        const evento = this.eventosQueBloqueiamAulas.find((e) => e.data === date);
        const legenda = evento?.legenda?.toLowerCase() || "";
        const descricao = evento?.descricao?.toLowerCase() || "";

        if (
          legenda.includes("lançamento bloqueado") ||
          legenda.includes("lancamento bloqueado") ||
          descricao.includes("lançamento bloqueado") ||
          descricao.includes("lancamento bloqueado")
        ) {
          return "B";
        }
        return "X";
      }
      if (this.isEventoLetivo(date)) {
        const evento = this.eventosLetivosDia.find((e) => e.data === date);
        const legenda = evento?.legenda?.toLowerCase() || "";
        const descricao = evento?.descricao?.toLowerCase() || "";

        if (
          legenda.includes("lançamento aberto") ||
          legenda.includes("lancamento aberto") ||
          descricao.includes("lançamento aberto") ||
          descricao.includes("lancamento aberto")
        ) {
          return "A";
        }
        return "L";
      }
      return "";
    },

    getEventColor(date) {
      const cores = [];
      const feriado = this.feriados.find((f) => f.data === date);
      if (feriado) cores.push(feriado.cor || "red");

      const eventoLetivo = this.eventosLetivosDia.find((e) => e.data === date);
      if (eventoLetivo) cores.push(eventoLetivo.cor || "green");

      const bloqueador = this.eventosQueBloqueiamAulas.find((e) => e.data === date);
      if (bloqueador) cores.push(bloqueador.cor || "red darken-2");

      return cores.length > 0 ? cores : "primary";
    },

    isToday(date) {
      const today = new Date().toISOString().split("T")[0];
      return date === today;
    },
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 8px;
}

.v-btn {
  text-transform: none;
}

.v-alert {
  border-radius: 8px;
}

.gap-3 > * {
  margin-right: 12px;
}

.gap-3 > *:last-child {
  margin-right: 0;
}

.e-label {
  margin-bottom: 8px;
  font-weight: 500;
}

.v-text-field--solo,
.v-select--solo,
.v-textarea--solo {
  border-radius: 6px;
}

.tooltip-content {
  font-size: 13px;
  line-height: 1.4;
  text-align: left;
}

.tooltip-list {
  padding-left: 8px;
  margin: 0;
}

.tooltip-list li {
  margin-bottom: 4px;
  list-style: none;
}

.calendar-container {
  max-width: 100%;
}

.calendar-card {
  width: 100%;
  max-width: 400px;
}

.events-card {
  max-height: 300px;
  overflow-y: auto;
}

.date-label {
  font-weight: bold;
  color: #1976d2;
  min-width: 50px;
}

.v-badge .v-badge__badge {
  font-size: 10px;
  height: 16px;
  min-width: 16px;
}

@media (max-width: 600px) {
  .d-flex.flex-wrap .v-btn {
    width: 100%;
    margin-bottom: 8px;
    margin-right: 0 !important;
  }

  .d-flex.align-center {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .d-flex.align-center .ml-2 {
    margin-left: 0 !important;
    margin-top: 8px;
    align-self: flex-end;
  }
}
</style>
